import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { SearchBlock } from 'components/common/parts';
import { UniversalTable } from 'components/common/universal';
import { SearchableTable, SearchableTableContainer } from 'containers';
import { getUserCommunitiesAction } from 'actions';
import { makeSelector } from 'utils';
import { communityTableParams } from 'assets/static-data';
import { CommunityList, QueryParams } from 'interfaces';
import { getMatchParam } from 'helpers';

interface IProps extends SearchableTable {}

const UsersCommunities: React.FC<IProps> = ({
  match,
  getList,
  isLoading,
  queryParams,
}) => {
  const { data, recordsFiltered } = useSelector<any, CommunityList>(
    makeSelector(['usersReducer', 'communityList'])
  );

  const idFromUrl = getMatchParam(match).id;

  useEffect(() => {
    onGetList(queryParams);
  }, []);

  const onGetList = (params: QueryParams) => {
    getList({ ...params, id: idFromUrl });
  };

  return (
    <>
      <SearchBlock onChange={getList} initialQuery={queryParams} />
      <UniversalTable
        {...communityTableParams}
        data={data}
        total={recordsFiltered}
        onChange={onGetList}
        isLoading={isLoading}
        initialQuery={queryParams}
      />
    </>
  );
};

export default SearchableTableContainer({
  getListAction: getUserCommunitiesAction,
  isInitialized: false,
  reducerName: 'usersReducer',
  queryName: 'communityQueryParams',
  isEqualSearch: true,
})(UsersCommunities);
